import UsersIndex from '@/views/Users/UsersIndex.vue'
import AddUserView from "@/views/Users/AddUserView.vue"
import EditUserView from "@/views/Users/EditUserView.vue"
import UserDetails from '@/views/Users/UserDetails.vue'
import StaticsticsIndex from '@/views/Statistics/StaticsticsIndex.vue'
import StudentAffairsStaticsticsIndex from '@/views/Statistics/StudentAffairsStaticsticsIndex.vue'
import AcademicStaticsticsIndex from '@/views/Statistics/AcademicStaticsticsIndex.vue'
export default [
  {
    path: '/statistics',
    name: 'statistics',
    component: StaticsticsIndex,
    meta: { 
      requiresAuth: true,
      title: 'statistics.breadcrumbs',
    },
  },
   {
    path: '/statistics',
    name: 'student-affairs-statistics',
    component: StudentAffairsStaticsticsIndex,
    meta: { 
      requiresAuth: true,
      title: 'statistics.breadcrumbs',
    },
  },
     {
    path: '/statistics',
    name: 'academic-statistics',
    component: AcademicStaticsticsIndex,
    meta: { 
      requiresAuth: true,
      title: 'statistics.breadcrumbs',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: UsersIndex,
    meta: { 
      title: 'users.breadcrumbs.users',
      breadcrumbKey: 'users.breadcrumbs.users'
    },
    children: [
      {
        path: '/users/add',
        name: 'users.add',
        component: AddUserView,
        meta: { 
          requiresAuth: true,
          title: 'users.breadcrumbs.addUser',
          breadcrumbKey: 'users.breadcrumbs.addUser'
        },
      },
      {
        path: '/users/:id/edit',
        name: 'users.edit',
        component: EditUserView,
        meta: { 
          requiresAuth: true,
          title: 'users.breadcrumbs.editUser',
          breadcrumbKey: 'users.breadcrumbs.editUser'
        },
        props: true
      },
      {
        path: '/users/:id',
        name: 'user-details',
        component: UserDetails,
        meta: { 
          requiresAuth: true,
          title: 'users.breadcrumbs.userDetails',
          breadcrumbKey: 'users.breadcrumbs.userDetails'
        },
      }
    ]
  },
]